import styled from 'styled-components';
import { Spin } from 'antd';

export const Loading = () => <SpinWrapper>
  <StyledSpin size='large' />
</SpinWrapper>;

const SpinWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  min-height: 120px;
`;

const StyledSpin = styled(Spin)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 55px;
    height: 55px;
`;